import { useCallback } from 'react';
import { TradePair } from '../../context/chart/chartTypes';
import { formatUSD } from '../../helpers';
import { preventOverflow } from '../../web3/utils';
import AssetInput from '../AssetInput';
import { TextInputProps } from '../TextInput';
import useTokenStats from '../../hooks/web3/useTokenStats';

type LimitPriceInputProps = Omit<TextInputProps, 'variant' | 'onChange' | 'name'> & {
    selectedTradePair: TradePair | undefined | null;
    value: string;
    onChange: (value: string) => void;
    variant?: 'primary' | 'secondary';
};

const LimitPriceInput: React.FC<LimitPriceInputProps> = ({
    variant = 'primary',
    selectedTradePair,
    value,
    onChange,
}) => {
    const tokenStats = useTokenStats();

    const entryPrice =
        tokenStats && selectedTradePair?.chartSymbol
            ? tokenStats?.[selectedTradePair.chartSymbol]?.price
            : undefined;

    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const { value } = e.target;

            onChange(preventOverflow(value));
        },
        [onChange]
    );

    return (
        <AssetInput
            className='limit-price-input'
            variant={variant}
            label='Limit Price'
            sideLabel={
                <>
                    Mark Price:{' '}
                    {!entryPrice
                        ? '-'
                        : formatUSD(entryPrice || 0, {
                              minDecimals: 2,
                              maxDecimals: selectedTradePair?.decimalFormatting,
                          })}
                </>
            }
            onSideLabelClick={() =>
                entryPrice ? onChange(preventOverflow(entryPrice || '0')) : undefined
            }
            asset={'USD'}
            name='limitPrice'
            value={value}
            onChange={handleChange}
        />
    );
};

export default LimitPriceInput;
